import { Component, ViewChild } from '@angular/core';
import { DsButtonIntent, DsButtonVariants } from '@levelaccess/design-system';
import { ModalContainerComponent } from '../../modals/modal-container.component';
import { IModal } from '../../modals/modal.interface';

@Component({
  templateUrl: './turn-off-monitoring-confirmation.component.html',
  standalone: false,
})
export class TurnOffMonitoringConfirmationComponent implements IModal {
  @ViewChild(ModalContainerComponent, { static: true })
  public container: ModalContainerComponent;
  public confirmed: boolean;
  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  public readonly DsButtonIntent: typeof DsButtonIntent = DsButtonIntent;

  constructor() {}

  public close(): void {
    this.container.closeModal();
  }

  public onConfirm(): void {
    this.confirmed = true;
    this.close();
  }
}
